import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

type Props = {
  background?: string;
  color?: string;
  ghost?: boolean;
  danger?: boolean;
  warning?: boolean;
  small?: boolean;
} & React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

function Button({
  children,
  background,
  color,
  ghost,
  danger,
  warning,
  small,
  disabled,
  ...props
}: Props) {
  return (
    <Container
      small={small}
      ghost={ghost}
      danger={danger}
      warning={warning}
      background={background}
      color={color}
      disabled={disabled}
      {...props}
    >
      {children}
    </Container>
  );
}

export default Button;

const Container = styled.button<Props>`
  display: flex;
  height: ${(props: Props) => (props.small ? '48px' : '64px')};
  align-items: center;
  justify-content: center;
  color: ${(props: Props) => (props.color ? props.color : '#fff')};
  background: ${(props: Props) => (props.background ? props.background : '#2c9918')};
  margin-top: 8px;
  border-radius: 64px;
  width: 100%;
  border: 0;
  font-size: 20px;
  /* width: calc(100vw - 16px); */
  /* margin-left: 8px; */
  ${(props: Props) =>
    props.ghost &&
    css`
      background: none;
      color: rgba(255, 255, 255, 0.8);
    `}
  ${(props: Props) =>
    props.danger &&
    css`
      background: #e80e0c;
      color: #fff;
    `}
    ${(props: Props) =>
      props.warning &&
      css`
        background: #ffc107;
        color: #000;
      `}
      ${(props: Props) =>
        props.disabled &&
        css`
          opacity: 0.2;
        `}
`;
